import React, { FC, useState } from 'react'
import { Button, Menu, Stack } from '@mui/material'
import { FilterAlt } from '@mui/icons-material'
import { useTranslation } from '@contexts/translation'
import { useFetchData } from '@api/fetchData'
import { makeStyles } from '@mui/styles'
import API_URL from '@config/services'
import { add } from 'date-fns'
import FiltersForm from './FiltersForm'

interface FiltersElementProps {
  defaultQueries?: Record<string, any>
  handleQueries: (queries: Record<string, any>) => void
  resetPage?: () => void
  operation?: string | number
  hideIcon?: boolean
  operationId?: string | number
}

const useStyles = makeStyles(() => ({
  menuPaper: {
    maxHeight: 'calc(100% - 32px)',
    width: 400
  }
}))

/**
 * FiltersElement Component - Displays a filter button and menu for filtering table data
 */
const FiltersElement: FC<FiltersElementProps> = ({
  defaultQueries = {},
  handleQueries,
  resetPage,
  operation,
  hideIcon,
  operationId
}) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const { data: contractsSupplierData } = useFetchData(
    API_URL.SUPPLIERS.GET_SUPPLIERS_LIST_DROPDOWNS(operation)
  )

  const contractSupplierOptions = contractsSupplierData?.results?.map(
    (supplier: any) => ({ id: supplier.id, name: supplier.display })
  )

  return (
    <div>
      <Button
        variant="outlined"
        onClick={handleClick}
        startIcon={!hideIcon && <FilterAlt />}
        data-testid="Button-93d93e99-5cd2-4cb5-a7da-6bb9a82ebab7"
        aria-label={t('filter')}
      >
        {t('filter')}
      </Button>

      <Menu
        id="filters-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        classes={{ paper: classes.menuPaper }}
      >
        <Stack direction="column" sx={{ p: 2 }} spacing={2}>
          <FiltersForm
            defaultQueries={defaultQueries}
            operationId={operationId || operation}
            contracts
            contractSupplierOptions={contractSupplierOptions}
            handleClose={handleClose}
            handleQueries={handleQueries}
            resetPage={resetPage}
          />
        </Stack>
      </Menu>
    </div>
  )
}

export default FiltersElement
